import styled from "styled-components";

export const StyledStatsBar = styled.div`
  display: flex;
  width: 100%;
  overflow: hidden;
  margin-bottom: 30px;
`;
